export class RegexPatternRes {
    captureGroup?: number = 0;
    pattern!: string;
}

export class RegexPatternReq {
    captureGroup?: number = 0;
    pattern!: string;
}